module.exports = __webpack_public_path__ + "img/logo-main.baaa2143.svg";